import React from 'react';

import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import { CheckboxCellContent } from 'app/shared/componentsRestyled/coreDesignSystem/Table/TableCDS/cellContent';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { getValueOrDash } from 'utils/data';

import ActionButton from './ActionButton';
import { MIN_COLUMNS_NUMBER } from './LoanDenial.constants';
import { emptyMessageCellStyles } from './LoanDenial.styles';

const isPlainValue = value => !value?.content;

export const getTableConfig = ({
  borrowerOptions,
  HMDACodeMap,
  isActionDisabled,
  isEditAllowed,
  editableRowId,
  setEditableTableData,
  deleteLoanDenial,
}) => ({
  name: {
    label: 'Denial Reasons',
    width: '15%',
    colSpan: ({ name }) => name?.colSpan,
    customStyles: ({ name }) => name?.customStyles,
    content: ({ name }) => name?.content ?? name,
    renderContentAsText: ({ name }) => isPlainValue(name),
  },
  HMDACode: {
    label: 'HMDA Code',
    width: '15%',
    content: ({ HMDACode }) => HMDACode?.content ?? getValueOrDash(HMDACodeMap[HMDACode]),
    renderContentAsText: ({ HMDACode }) => isPlainValue(HMDACode),
  },
  isDenialDueToCredit: {
    label: 'Credit Denial',
    width: '10%',
    content: ({ isDenialDueToCredit }) =>
      isDenialDueToCredit?.content ?? (
        <CheckboxCellContent isDisabled isChecked={!!isDenialDueToCredit} />
      ),
    align: HORIZONTAL_ALIGNMENT.CENTER,
  },
  ...borrowerOptions.reduce((acc, curr, ind) => {
    acc[`borrower${ind}`] = {
      label: curr.name,
      width: '10%',
      content: row => {
        const cellValue = row[`borrower${ind}`];

        return (
          cellValue?.content ?? (
            <CheckboxCellContent
              isDisabled
              isChecked={row.selectedBorrowers?.includes(curr.value)}
            />
          )
        );
      },
      align: HORIZONTAL_ALIGNMENT.CENTER,
    };

    return acc;
  }, {}),
  isAffiliate: {
    label: 'Affiliate credit',
    width: '10%',
    content: ({ isAffiliate }) =>
      isAffiliate?.content ?? <CheckboxCellContent isDisabled isChecked={!!isAffiliate} />,
    align: HORIZONTAL_ALIGNMENT.CENTER,
  },
  action: {
    label: 'Action',
    width: '10%',
    content: rowData =>
      rowData.action?.content ?? (
        <ActionButton
          deleteTableData={deleteLoanDenial}
          isDisabled={isActionDisabled || (!!editableRowId && rowData.id !== editableRowId)}
          isEditDisabled={!isEditAllowed || rowData.id === editableRowId}
          rowData={rowData}
          setEditableTableData={setEditableTableData}
        />
      ),
    align: HORIZONTAL_ALIGNMENT.CENTER,
  },
});

export const getNotFoundTableData = borrowersNumber => [
  {
    name: {
      position: 1,
      customStyles: emptyMessageCellStyles,
      colSpan: MIN_COLUMNS_NUMBER + (borrowersNumber ?? 1),
      content: <NoAvailableMessage className="empty-message-row" message="No data" />,
    },
  },
];
